/**
 * ======================================================================== 
 * RMS Local Navi @{versionFull}
 * ======================================================================== 
 * 
 * ======================================================================== 
 * Author: ナカカド リー (Lee Nakakead)
 * ======================================================================== 
 */

(function($) {
  var defaultSettings = {
    classDisabled: 'disabled',
    classSelected: 'selected',
    classActive: 'active',
    classShow: 'show',
    targetNaviMain: '.rms-navi-local-main',
    targetNaviSub: '.rms-navi-local-sub',
    targetDropdown: '.dropdown',
    targetDropdownMenu: '.dropdown-menu',
  };

  $.fn.rmsLocalNavi = function(callerSettings) {
    callerSettings = $.extend({}, defaultSettings, callerSettings || {}); // Add defaultSettings to callerSettings

    // Constructor
    // ===========
    function RMSLocalNavi(_self, _settings) {
      this.self = _self;
      this.settings = _settings;
    }

    // Extend Class with functions
    // ===========================
    RMSLocalNavi.prototype = {
      /* ============ Functions ============ */
      // Initialize
      // ==========
      _init: function() {
        this._setSubNaviMenuItem(this.settings.targetNaviSub);
      },
      // Function - Set Active State Navi Sub Menu
      // ===============================
      _selectNaviSubMenu: function(_target) {
        var $target = $(_target);
        if ($target.length) {
          var subnaviTargetString = $target.parents('ul').attr('data-target'); // Sub menu target
          var pageTargetString = $target.attr('data-target'); // Sub menu-item target
          this._deselectNaviSubMenuItems(this.settings.targetNaviSub); // Function - Remove select state from navi sub menu-items
          var $subNavi = $(this.self).find(this.settings.targetNaviSub).find(subnaviTargetString);
          if ($subNavi.length) {
            $subNavi.addClass(this.settings.classSelected); // Add .selected class to targetted Sub Navi Menu
            $subNavi.find(pageTargetString).addClass(this.settings.classSelected); // Add .selected class to targetted Sub Navi Menu Item
          }
          this._selectNaviDropdownMenu($target); // Function - Set Selected State on Dropdown Menu
        }
      },
      // Function - Remove select state from navi sub menu-items
      // =======================================================
      _deselectNaviSubMenuItems: function(_target) {
        var $menus = $(this.self).find(_target);
        if ($menus.length) {
          var classSelected = this.settings.classSelected;
          $menus.find('.' + classSelected).removeClass(classSelected); // Remove all .selected classes on Sub Navi Menu
        }
      },

      // Function - Set Active State on Dropdown Menu
      // ============================================
      _selectNaviDropdownMenu: function(_target) {
        var $dropdownMenu = $(this.self).find(this.settings.targetDropdownMenu);
        if ($dropdownMenu.length) {
          this._deselectNaviDropdownMenu($dropdownMenu);
          var $ddmItem = $(_target);
          if ($ddmItem.length) {
            var $ddMenu = $ddmItem.parents(this.settings.targetDropdown);
            $ddmItem.addClass(this.settings.classSelected); // Add .selected class to dropdown menu item
            this._selectNaviMainMenuItem($ddMenu); // Function - Set Active State on Main Navi
          }
        }
      },
      _deselectNaviDropdownMenu: function(_target) {
        var $ddMenu = $(_target);
        if ($ddMenu.length) {
          var classSelected = this.settings.classSelected;
          $ddMenu.find('.' + classSelected).removeClass(classSelected); // Remove all .selected classes on Sub Navi Menu
        }
      },
      // Function - Set Active State on Main Navi
      // ========================================
      _selectNaviMainMenuItem: function(_target) {
        var $target = $(_target);
        if ($target.length) {
          if ($target.is(this.settings.targetDropdown)) {
            this._deselectNaviMainMenuItem($(this.self).find(this.settings.targetNaviMain + ' .' + this.settings.classSelected));
            $target.addClass(this.settings.classSelected);
          }
        }
      },
      _deselectNaviMainMenuItem: function(_target) {
        var $target = $(_target);
        if ($target.length) {
          if ($target.is('.' + this.settings.classSelected)) {
            $($target).removeClass(this.settings.classSelected);
          }
        }
      },

      // Function - Set original Selected State on Sub Navi
      // ==================================================
      _setSubNaviMenuItem: function(_target) {
        var $subnavi = $(this.self).find(_target);
        var $selected = $subnavi.find('ul .' + this.settings.classSelected);
        if ($selected.length) {
          if ($selected.length > 1) { // If more than 1 are selected
            $selected.slice(1, $selected.length).removeClass(this.settings.classSelected); // Remove .selected class from all menu-items except first result
          }
          $subnavi.find('ul').removeClass(this.settings.classSelected); // Remove .selected class on all <ul>
          $selected.first().parents('ul').addClass(this.settings.classSelected); // Add .selected class to parent <ul> of menu-item
        }
        this._setNaviDropdownMenuItem($selected.first()); // Function - Set Selected State on Dropdown Menu
      },
      // Function - Set original Selected State on Dropdown Menu
      // =======================================================
      _setNaviDropdownMenuItem: function(_target) {
        var $subnavimenuItem = $(_target);
        if ($subnavimenuItem.length) {
          var id = '#' + $subnavimenuItem.attr('id');
          var $dropdownMenuItem = $(this.self).find(this.settings.targetDropdownMenu + ' a[data-target="' + id + '"], ' + this.settings.targetDropdownMenu + ' button[data-target="' + id + '"]').first(); // Select targetted .dropdown-menu
          if ($dropdownMenuItem.length) {
            $dropdownMenuItem.addClass(this.settings.classSelected); // Add .selected class
            this._setNaviMainMenuItem($dropdownMenuItem); // Function - Set Selected State on Main Navi
          }
        }
      },
      // Function - Set original Selected State on Main Navi
      // ===================================================
      _setNaviMainMenuItem: function(_target) {
        var $target = $(_target);
        if ($target.length) {
          $(this.self).find(this.settings.targetNaviMain).find('li.' + this.settings.classSelected).removeClass(this.settings.classSelected);
          $target.parents('li' + this.settings.targetDropdown).addClass(this.settings.classSelected);
        }
      },
      /* ============ /Functions ============ */

      /* ============ Events ============ */
      // Function Click Event - Anchor element
      // =====================================
      _eventClickAnchor: function(_e) {
        var $this = $(_e.currentTarget);
        if ($this.length && $this.is('.' + this.settings.classDisabled)) {
          _e.preventDefault(); // Prevent navigating when disabled
          _e.stopPropagation();
          return false;
        }
        if ($this.is('[data-target]')) { // If button contains data-target attribute
          this._selectNaviSubMenu($this); // Function - Select Navi Sub Menu
        }
      },
      // Function Click Event - Button element
      // =====================================
      _eventClickButton: function(_e) {
        var $this = $(_e.currentTarget);
        if ($this.length) {
          if ($this.parents(this.settings.targetDropdown).is('.' + this.settings.classSelected)) {
            _e.preventDefault(); // Prevent navigating when disabled
            _e.stopPropagation();
            return false;
          }
        }
      },
      /* ============ /Events ============ */
    };

    return this.each(function() {
      var instance = new RMSLocalNavi(this, callerSettings); // New Local Navi
      instance._init(); // Initialize
      /* Events */
      $(this).on('click', 'a', function(_e) {
        instance._eventClickAnchor(_e);
      }); // Function Click Event - Anchor element
      $(this).on('click', 'button[type="button"]', function(_e) {
        instance._eventClickButton(_e);
      }); // Function Click Event - Button element
      $(this).on('show.bs.dropdown', '.dropdown.selected', function() {
        return false;
      });
      /* /Events */
    });
  };

  $('.rms-navi-local').rmsLocalNavi(); // Initialize Local Navi
})(jQuery);